import { useTheme } from '@emotion/react';
import { AppTheme } from 'presentation/theme/theme';

const useAppTheme = (): AppTheme => {
  const theme = useTheme();

  return theme as AppTheme;
};

export default useAppTheme;
